import { useQuery } from "@tanstack/react-query"
import type { TokenPriceChangeData } from "./coingeckoResponse"

export const tokenPriceChangesQueryKey = ["token-price-changes"]
const STALE_TIME_MS = 5 * 60 * 1000

export async function tokenPriceChanges(): Promise<TokenPriceChangeData> {
  const response = await fetch("/api/token-price-changes")

  if (!response.ok) {
    throw new Error("Failed to fetch token price changes")
  }

  return response.json()
}

export function useTokenPriceChanges() {
  return useQuery({
    queryKey: tokenPriceChangesQueryKey,
    queryFn: tokenPriceChanges,
    staleTime: STALE_TIME_MS,
    refetchInterval: STALE_TIME_MS,
  })
}

export function createTokenPriceChangesQueryOptions() {
  return {
    queryKey: tokenPriceChangesQueryKey,
    queryFn: tokenPriceChanges,
    staleTime: STALE_TIME_MS,
    refetchInterval: STALE_TIME_MS,
  }
}
